import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

function LoadingSpinner() {
  return (
    <Segment>
      <Dimmer active inverted>
        <Loader />
      </Dimmer>
    </Segment>
  );
}

export default LoadingSpinner;
